import RemoteCall from "../../util/RemoteCall";

let remoteCall = new RemoteCall('/api/auth/dingding');


function getPopLoginCodeAsync(param) {
    return remoteCall.invoke("/getPopLoginCode", param);
}


export default {
    getPopLoginCodeAsync,
}